import React, {useEffect, useState} from "react";
import s from "./TableHeader.module.css";
import {useDispatch, useSelector} from "react-redux";
import {
    setSelectedFullBranch,
    setSelectedFullBranchForPricesTable,
    sortDataTable,
    sortDataTableForPrices
} from "../../../../../Redux/content-reducer";
import {Box, Grid, Typography} from "@mui/material";

import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(theme => ({
    headerCellBox: {
        position: "relative",
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
        height: `100%`,
        '& > .MuiTypography-root': {
            fontWeight: 'bold'
        }
    }
}));

const TableCell = (props) => {
    const classes = useStyles();
    return (
        <Box className={classes.headerCellBox}
             sx={{flexDirection: props.caption === "selectColumn" ? 'column' : 'row'}}>
            <Typography>
                {props.displayCaption}
            </Typography>
            {
                props.caption === "selectColumn" && <div className={s.selectDeselectAllWrapper}>
                    <input type="checkbox" onChange={props.setSelectAll} className={s.selectDeselectAll}
                           checked={props.isAllRowsSelected}/>
                    <Box>{props.selectedRows.length}</Box>
                </div>
            }
            {
                props.caption === "selectColumn" && <Box>
                    <Typography>
                        {`סך ${props.tableData.length}`}
                    </Typography>
                </Box>
            }
            {
                props.sortPropertyName !== '' ?
                    <span
                        className={`${props.getClassNamesFor(props.sortPropertyName)} ${s.clickedHeader} ${props.caption === 'selectColumn' ? 'sortSelected' : ''}`}
                        onClick={(e) => props.sortedItems(props.sortPropertyName, e)}>

                    </span> :
                    <span></span>
            }
        </Box>

    )
}

export const TableHeader = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {contentData} = useSelector(state => state);
    let [sort, setSort] = useState('nonSort');
    const [tableData, setTableData] = useState([]);
    const [defaultStateOfTableData, setDefaultStateOfTableData] = useState([]);
    const [isAllRowsSelected, setAllRowsIsSelected] = useState(false);
    const [selectedRows, setSelectRows] = useState([]);
    const attr = {xs: props.size && props.size};
    useEffect(() => {
        if (contentData.isActivePromosScreen) {
            if (contentData.isPrintListOpened) {
                setTableData(contentData.printListDataForPromos);
            } else {
                setTableData(contentData.data);
            }
        } else {
            if (contentData.isPrintListOpened) {
                setTableData(contentData.printListDataForItems);
            } else {
                setTableData(contentData.dataForRegPrices);
            }
        }
    }, [
        contentData.dataForRegPrices,
        contentData.printListDataForItems,
        contentData.isPrintListOpened,
        contentData.data,
        contentData.printListDataForPromos,
        contentData.isActivePromosScreen,
    ]);

    useEffect(() => {
        if (contentData.isActivePromosScreen) {
            setDefaultStateOfTableData(contentData.isPrintListOpened ? contentData.printListDataForPromos : contentData.defaultDataForPromos);
        } else {
            setDefaultStateOfTableData(contentData.isPrintListOpened ? contentData.printListDataForItems : contentData.defaultDataForItems);
        }
        setSort('nonSort');
    }, [contentData.isPrintListOpened, contentData.isActivePromosScreen]);
    //
    // useEffect(() => {
    //     setTableData(defaultStateOfTableData);
    // }, [defaultStateOfTableData])

    useEffect(() => {
        let isAllSelected = [...tableData].every(key => {
            return key.selectedRow === true;
        });
        let selectedRowsArr = [...tableData].filter(key => {
            return key.selectedRow === true;
        });
        setAllRowsIsSelected(isAllSelected);
        setSelectRows(selectedRowsArr);
    }, [tableData])
    const sortedItems = (key, event) => {
        const targetHeader = event.target;
        props.setSortTarget(key);
        if (targetHeader.className.indexOf('sortSelected') > -1) {
            if (targetHeader.className.indexOf('nonSort') > -1) {
                setSort('ascending');
            } else {
                setSort('nonSort');
            }
        } else {
            if (targetHeader.className.indexOf('nonSort') > -1) {
                setSort('descending');
            } else if (targetHeader.className.indexOf('descending') > 1) {
                setSort('ascending');
            } else {
                setSort('nonSort');
            }
        }
        // if(sort === 'nonSort'){
        //     setSort('ascending');
        // } else if (sort === 'ascending'){
        //     setSort('descending');
        // } else {
        //     setSort('nonSort');
        // }
    };

    useEffect(() => {
        let sortableRows = [...tableData];
        if (props.sortTarget !== null && props.sortPropertyName === props.sortTarget && sort !== 'nonSort') {
            sortableRows.sort((a, b) => {
                let firstVal, secondVal;
                if (props.sortTarget === 'RegularPrice' || props.sortTarget === 'SaleVal1' || props.sortTarget === 'SaleVal2') {
                    firstVal = Number(a[props.sortTarget]);
                    secondVal = Number(b[props.sortTarget]);
                } else if (props.sortTarget === 'SaleEndDateTimeUtc') {
                    firstVal = new Date(a[props.sortTarget] === "" ? "9999-12-31 00:00:00" : a[props.sortTarget]);
                    secondVal = new Date(b[props.sortTarget] === "" ? "9999-12-31 00:00:00" : b[props.sortTarget]);
                } else {
                    firstVal = typeof a[props.sortTarget] === `string` ? a[props.sortTarget].toLowerCase() : a[props.sortTarget];
                    secondVal = typeof b[props.sortTarget] === `string` ? b[props.sortTarget].toLowerCase() : b[props.sortTarget];
                }
                if (firstVal < secondVal) {
                    return sort === 'descending' ? -1 : 1;
                }
                if (firstVal > secondVal) {
                    return sort === 'descending' ? 1 : -1;
                }
                return 0;
            });
            if (contentData.isActivePromosScreen) {
                dispatch(sortDataTable(sortableRows));
            } else {
                dispatch(sortDataTableForPrices(sortableRows));
            }
        } else if (props.sortPropertyName === props.sortTarget && sort === 'nonSort') {
            if (contentData.isActivePromosScreen) {
                dispatch(sortDataTable(defaultStateOfTableData));
            } else {
                dispatch(sortDataTableForPrices(defaultStateOfTableData));
            }
        }
    }, [sort, props.sortTarget]);

    const setSelectAll = (e) => {
        if (contentData.isActivePromosScreen) {
            dispatch(setSelectedFullBranch(e.target.checked))
        } else {
            dispatch(setSelectedFullBranchForPricesTable(e.target.checked));
        }
    };


    const getClassNamesFor = (name) => {
        if (!sort) {
            return;
        }
        return props.sortTarget === name ? s[sort] : s.nonSort;
    };


    return (
        <>
            {
                props.size ?
                    <Grid item {...attr} >
                        <TableCell
                            caption={props.caption}
                            displayCaption={props.displayCaption}
                            sortPropertyName={props.sortPropertyName}
                            setSelectAll={setSelectAll}
                            isAllRowsSelected={isAllRowsSelected}
                            selectedRows={selectedRows}
                            getClassNamesFor={getClassNamesFor}
                            sortedItems={sortedItems}
                            classes={classes}
                            tableData={tableData}
                        />
                    </Grid>
                    :
                    <Grid item xs>
                        <TableCell
                            caption={props.caption}
                            displayCaption={props.displayCaption}
                            sortPropertyName={props.sortPropertyName}
                            setSelectAll={setSelectAll}
                            isAllRowsSelected={isAllRowsSelected}
                            selectedRows={selectedRows}
                            getClassNamesFor={getClassNamesFor}
                            sortedItems={sortedItems}
                            classes={classes}
                            tableData={tableData}
                        />
                    </Grid>
            }
        </>
    )
}

